import { Container, Link, Stack, Text, useDisclosure, Icon } from "@chakra-ui/react"
import { FaXTwitter } from "react-icons/fa6"
import { FaRegCopyright } from "react-icons/fa"
import ModuleVersions from "../Common/ModuleVersions"
import { useQuery } from "@tanstack/react-query"
import { getAGB } from "../../utils"
import { useSettings } from "../UI/settings-context"
import { useEffect, useState } from "react"
import { IconType } from "react-icons/lib"
import { FiFacebook, FiInstagram, FiLinkedin, FiYoutube } from "react-icons/fi"

type SocialLink = {
  href: string
  icon: IconType
}

const Footer = () => {
  const { open, onToggle, onClose } = useDisclosure()
  
  const [agbLink, setAgbLink] = useState<string | null>(null)
  const {data: agb} = useQuery({
    ...getAGB()
  })

  useEffect(() => {
    if(agb?.agb) {
      setAgbLink(agb.agb.path)
    }
  }, [agb])
  
  const footerLinks = [
    {name: "Newsletter",link: "/newsletter"},
    {name: "Kontakt",link: "/kontakt"},
    {name: "Über uns",link: "/ueber-uns"},
    {name: "AGB",link: agbLink ?? "/"},
    {name: "Impressum",link: "/impressum"},
    {name: "Datenschutz",link: "/datenschutz"},
  ]

  const [socialLinks, setSocialLinks] = useState<SocialLink[]>([])
  const policy = useSettings()?.policy

  useEffect(() => {
    const links = []

    if(policy?.link_facebook) links.push({href: policy.link_facebook, icon: FiFacebook})
    if(policy?.link_instagram) links.push({href: policy.link_instagram, icon: FiInstagram})
    if(policy?.link_linkedin) links.push({href: policy.link_linkedin, icon: FiLinkedin})
    if(policy?.link_twitter) links.push({href: policy.link_twitter, icon: FaXTwitter})
    if(policy?.link_youtube) links.push({href: policy.link_youtube, icon: FiYoutube})

    setSocialLinks(links)
  }, [policy])

  return (
    <Container
      maxW="full"
      as="footer"
      bg="main"
      color="white"
      mt="5em"
      data-testid="footer"
    >
      <Stack
        gap="12"
        alignItems="center"
        justifyContent="center"
        py={4}
      >
        <Stack gap="6" direction={{ base: "column", md: "row" }}>
          {footerLinks.map((item, i) => (
            <Link
              key={i}
              href={item.link}
              color="white"
              target={item.name === "AGB" ? "_blank" : "_self"}
              rel={item.name === "AGB" ? "noopener noreferrer" : undefined}
            >
              {item.name}
            </Link>
          ))}
        </Stack>
      </Stack>
      <Stack
        gap="12"
        alignItems="center"
        justifyContent="center"
        direction={{ base: "column", md: "row" }}
        py={4}
      >
        <Stack direction="row" gap={{ base: "4", md: "3" }}>
          {socialLinks?.map((social, i) => (
            <Link
              key={i}
              href={social.href}
              aria-label={social.href}
              target="_blank"
              color="white"
              mx={5}
            >
              <Icon size="md" as={social.icon} />
            </Link>
          ))}
        </Stack>
      </Stack>
      <Stack
        py={4}
        direction="row"
        justifyContent="center"
        onClick={onToggle}
        cursor="pointer"
        alignItems="center"
      >
        <FaRegCopyright size={12} />
        <Text fontSize="xs"> Wochen-Zeitung {(new Date().getFullYear())}</Text>
        <ModuleVersions
          isOpen={open}
          onClose={onClose}
        />
      </Stack>
    </Container>
  )
}

export default Footer
